/**
 * @private
 * @name increment
 * @desc Increment a UID specific to a string / object property
 * @param {String} str
 * @returns {String}
 */
const incrementer = {};
function increment(str) {
  if (typeof incrementer[str] === 'undefined') {
    resetUidByPrefix(str);
  } else {
    incrementer[str]++;
  }
  return incrementer[str];
}


/**
 * @name uid
 * @desc Create a Unique ID
 * @param {String} str
 * @returns {String}
 * @memberof utils
 */
export function uid(str) {
  return str + '-' + increment(str);
}


/**
 * @name getUidByPrefix
 * @desc Get an existing UID by string prefix
 * @param {String} str
 * @returns {String}
 * @memberof utils
 */
export function getUidByPrefix(str) {
  return ((typeof str === 'string' && incrementer[str]) ? `${str}-${incrementer[str]}` : '');
}


/**
 * @name resetUidByPrefix
 * @desc Note: This is really a test util so we can accurately test UIDs as part of an expected object
 * @param {String} str
 * @returns {String}
 * @memberof utils
 */
export function resetUidByPrefix(str) {
  if (typeof str === 'string') incrementer[str] = 1;
  return getUidByPrefix(str);
}
